import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 56px;
  overflow: hidden;
  * {
    font-family: inherit;
  }
`;

export const ContentArea = styled.main`
  flex: 1;
  padding: 48px 74px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
`;
